import styled from 'styled-components'

export const Answers = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
`
